import React, { useEffect } from "react";
import useNotificationContainer from "../../../../../../common-deprecated/hooks/useNotificationContainer";
import Notification from "./Notification";
import * as Styles from "./NotificationContainer.styles";
import { isRetailer } from "../../../../../../common-deprecated/utils";
import { useCommonSelector } from "../../../../../../common-deprecated/redux/commonStore";

type NotificationContainerPropsType = {
    contentWidth: number;
    contentSpacingLeft: number;
};

const NotificationContainer = ({
    contentWidth,
    contentSpacingLeft,
}: NotificationContainerPropsType): JSX.Element | null => {
    const { notifications, onTransitionEnd } = useNotificationContainer();
    const commonSettings = useCommonSelector((state) => state.commonSettings);

    useEffect(() => {
        // When there are more than 3 notifications the one triggered first should be closed
        if (notifications.length > 1) {
            // Get the notification with the lowest index (this will be the first one triggered).
            const lowestIndex = Math.min(
                // The notificationIndex will always be set, the weird optional typing is because the old build does not have this but we use the new flow
                // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                ...notifications.map((notification) => notification.displaySettings?.notificationIndex!),
            );

            onTransitionEnd(lowestIndex); // Remove the fist notification
        }
    }, [notifications.length, onTransitionEnd]);

    if (!notifications.length) return null;

    return (
        <Styles.Wrapper
            contentWidth={contentWidth}
            spacingLeft={contentSpacingLeft}
            isRetailer={isRetailer(commonSettings)}
            aria-hidden
        >
            {notifications
                .filter((notification) => !notification.srOnly)
                .map((notification, index) => (
                    <Notification
                        onTransitionEnd={onTransitionEnd}
                        index={notification.displaySettings?.notificationIndex ?? index}
                        notification={notification}
                        key={notification.displaySettings?.notificationIndex ?? index}
                    />
                ))}
        </Styles.Wrapper>
    );
};

export default NotificationContainer;
